<div class="layout">
  <aside class="left-nav">
    <app-side-nav></app-side-nav>
  </aside>
  <main>
    <app-global-chat-drawer></app-global-chat-drawer>
    <app-header></app-header>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-feedback-drawer></app-feedback-drawer>
